import { render } from "./MessagesList.vue?vue&type=template&id=f31409be&scoped=true"
import script from "./MessagesList.vue?vue&type=script&lang=js"
export * from "./MessagesList.vue?vue&type=script&lang=js"

import "./MessagesList.vue?vue&type=style&index=0&id=f31409be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f31409be"]])

export default __exports__